import { SearchApi } from '@ps/api/search';
import {
  OrderEnumItem,
  SearchCommunityChannelMessageSortByEnumItem,
} from '@ps/api/types';
import { withClientAPI } from '@ps/functions/utils/api';

import type { ExtendedCommunityChannelMessage } from '../../types/ExtendedCommunityChannelMessage';
import { channelMessageSearchItemToMessage } from './channelMessageSearchItemToMessage';

const kDefaultPageSize = 50;

/**
 * Pinned-only page of channel messages, newest-pinned first. Used
 * to seed the Pinned Messages panel; live `pinnedAt` flips on
 * existing messages come through the ordinary channel-messages
 * subscription, so we don't need a separate Firestore sub for the
 * pinned view.
 */
export async function fetchPinnedMessages(
  creatorId: string,
  channelId: string,
  { pageSize = kDefaultPageSize }: { pageSize?: number } = {},
): Promise<ExtendedCommunityChannelMessage[]> {
  const api = withClientAPI(SearchApi);
  const res = await api.searchApiControllerSearchStoreCommunityChannelMessages({
    storeId: creatorId,
    channelId,
    pageNo: 1,
    pageSize,
    pinnedOnly: true,
    sortBy: SearchCommunityChannelMessageSortByEnumItem.PinnedAt,
    order: OrderEnumItem.Desc,
  });
  return res.data.rows.map(row =>
    channelMessageSearchItemToMessage(channelId, row),
  );
}
